@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.support

class ExtendedSupportItemDto (
    val category: SupportCategoryDto,
    val issues: Array<SupportIssueDto>,
)